//region :: Imports ::
import MComponent from '../Component';
import {ReactElement, ChangeEvent, RefObject, createRef} from 'react';
import {findDOMNode} from 'react-dom';
import {InputTextarea} from 'primereact/inputtextarea';
import {classNames} from 'primereact/utils';
import {FieldProps} from 'formik';
import {MNullable, setFieldValue} from '../../Utils';
import {evalulateBool, MBoolean} from './Control';

//endregion

export type MInputValueType = string | number | readonly string[];

/** */
type Props = {
    id: string;
    initialValue?: MInputValueType;
    maxLength: number;
    placeholderText?: string;
    readonly?: boolean;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    autoResize?: boolean;
    cols?: number;
    rows?: number;
    onChange?: (newValue: MInputValueType) => void;
}

/** */
type State = {
    value: MInputValueType;
}

/** */
class MTextArea extends MComponent<Props, State> {

    private readonly m_inputRef: RefObject<any>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.m_inputRef = createRef<any>();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.setFocus = this.setFocus.bind(this);
        this.input_onChange = this.input_onChange.bind(this);

    }

    /** */
    private initializeState(): void {

        this.state = {value: this.props.initialValue === undefined ? '' : this.props.initialValue};
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private input_onChange(event: ChangeEvent<HTMLTextAreaElement>): void {
        this.setValue(event.target.value);
    }

    /** */
    public setFocus(): void {

        setTimeout(() => {

            const element = findDOMNode(this.m_inputRef.current!) as MNullable<HTMLTextAreaElement>;
            element?.focus();

        }, 200);

    }

    /** */
    public setValue(newValue: MInputValueType): void {

        this.safeSetState((draft: State) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <InputTextarea id={this.props.id}
                           maxLength={this.props.maxLength}
                           autoResize={this.props.autoResize ?? false}
                           cols={this.props.cols ?? 30}
                           rows={this.props.rows}
                           placeholder={this.props.placeholderText}
                           readOnly={this.props.readonly ?? false}
                           disabled={evalulateBool(this.props.disabled)}
                           className={classNames(this.props.className, {'surface-50': this.props.readonly})}
                           {
                               ...this.props.fieldProps?.field
                           }
                           value={this.state.value}
                           onChange={this.input_onChange}
                           ref={this.m_inputRef}/>
        );

    }

}

export default MTextArea;
